import { request } from '@/lib/utils/request'

export const importTasks = (importData: FormData) => {
  return request.postFormData('/v1/tasks/import/', importData)
}
